import Link from "next/link";
import Player from "@/components/LottiePlayer";

export default function Grid() {
  return (
    <section className="flex flex-col items-center justify-center max-w-7xl font-['Inter'] mt-14">
      <div className="flex flex-col justify-center items-center text-center py-8 px-8 md:px-4" tabIndex={0}>
        <h3 className="text-center mx-auto main-top-title">
          CKAN expertise on demand
        </h3>
        <p className="body-text max-w-xl mt-4">
          Explore our CKAN-related services
        </p>
      </div>
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl w-full mt-16 mb-8 grid grid-cols-1 md:grid-cols-2 gap-8 px-4">
        {/*<div className="border border-2 md:row-span-2 shadow-xl rounded-2xl flex flex-col justify-end hover:shadow-2xl hover:cursor-pointer hover:cursor-pointer">
          <Link href="/ckan-saas">
            <div className="m-10 flex flex-col items-start">
              <Player
                autoplay
                loop
                src="assets/icons/connection.json"
                style={{ height: '80px', width: '80px' }}
              />
              <h5 className="text-2xl pt-3">
                CKAN as SaaS
              </h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20">
              </div>
              <h5 className="pt-3 max-w-xs body-text">
                Get more done, with less hassle without worrying about maintenance and support.
              </h5>
            </div>
          </Link>
  </div>*/}
        <div className="border border-2 shadow-xl rounded-2xl hover:shadow-2xl hover:cursor-pointer transition-all" tabIndex={0}>
          <Link href="/solutions/ckan/hosting">
            <div className="m-10 flex flex-col items-start">
              <Player
                autoplay
                loop
                src="/assets/icons/server-1.json"
                style={{ height: "80px", width: "80px" }}
              />
              <h5 className="text-2xl pt-3">CKAN Hosting</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-xs body-text">
                Managed CKAN in our cloud or yours. Take the hassle out of
                hosting.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border border-2 shadow-xl rounded-2xl hover:shadow-2xl hover:cursor-pointer transition-all" tabIndex={0}>
          <Link href="/solutions/ckan/support">
            <div className="m-10 flex flex-col items-start">
              <Player
                autoplay
                loop
                src="/assets/icons/support.json"
                style={{ height: "80px", width: "80px" }}
              />
              <h5 className="text-2xl pt-3">CKAN Support</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-xs body-text">
                Fast and reliable CKAN support from those who know it best.
              </h5>
            </div>
          </Link>
        </div>
        <div tabIndex={0} className="border border-2 md:col-span-2 shadow-xl rounded-2xl flex flex-col justify-end hover:shadow-2xl hover:cursor-pointer">
          <Link href="/solutions/ckan/development">
            <div className="m-10 flex flex-col items-start">
              <Player
                autoplay
                loop
                src="/assets/icons/browser.json"
                style={{ height: "80px", width: "80px" }}
              />
              <h5 className="text-2xl pt-3">CKAN Development</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-xs body-text">
                Tailor CKAN to your needs. Expert help from the team that built
                it.
              </h5>
            </div>
          </Link>
        </div>
        <div tabIndex={0} className="border border-2 shadow-xl rounded-2xl hover:shadow-2xl hover:cursor-pointer transition-all">
          <Link href="/solutions/ckan/consultancy">
            <div className="m-10 flex flex-col items-start">
              <Player
                autoplay
                loop
                src="/assets/icons/conference.json"
                style={{ height: "80px", width: "80px" }}
              />
              <h5 className="text-2xl pt-3">CKAN Consultancy</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-xs body-text">
                Expert guidance and best practices from CKAN veterans.
              </h5>
            </div>
          </Link>
        </div>
        <div tabIndex={0} className="border border-2 shadow-xl rounded-2xl hover:shadow-2xl hover:cursor-pointer transition-all">
          <Link href="/solutions/ckan/training">
            <div className="m-10 flex flex-col items-start">
              <Player
                autoplay
                loop
                src="/assets/icons/presentation-4.json"
                style={{ height: "80px", width: "80px" }}
              />
              <h5 className="text-2xl pt-3">CKAN Training</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-xs body-text">
                Elevate your skills with training from industry-leading CKAN
                experts.
              </h5>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
